module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['common-dialog-box', _vm.className]
  }, [_c('v-touch', {
    staticClass: "dialog-mask",
    attrs: {
      "tag": "div"
    },
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      },
      "tap": function($event) {
        _vm.handleClose({
          isMask: 1
        })
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-cont"
  }, [(_vm.showClose) ? _c('v-touch', {
    staticClass: "dialog-close",
    attrs: {
      "tag": "span"
    },
    on: {
      "tap": _vm.handleClose
    }
  }) : _vm._e(), _vm._v(" "), (_vm.title) ? _c('p', {
    staticClass: "txt",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }, [_vm._v("title")]) : _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "opt-group"
  }, _vm._l((_vm.buttons), function(v, index) {
    return _c('v-touch', {
      key: index,
      staticClass: "btn",
      style: (index === _vm.buttons.length - 1 ?
        {
          color: _vm.theme,
          borderColor: _vm.theme
        } :
        {}),
      attrs: {
        "tag": "span"
      },
      on: {
        "tap": function($event) {
          _vm.handleClick({
            index: index
          })
        }
      }
    }, [_vm._v("\n        " + _vm._s(v.label) + "\n      ")])
  }))], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3dde6a46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dialog.vue
// module id = 2507
// module chunks = 115